import React, { Component } from "react";
import Menu from '../../components/Menu/Menu';
import Header from '../../components/Header/Header';
import Cards from '../../components/Cards/Cards';
import CardsTramites from '../../components/CardsTramites/CardsTramites';
import Information from '../../components/Information/Information';
import Footer from '../../components/Footer/Footer';
import './Home.css';

class Home extends Component {



    render() {
        return (
            <div>
                <Menu />
                <Header />
                <div className="main-container">
                    <Cards />
                    <CardsTramites />
                </div>
                <Information />
                <Footer />
            </div>
        );
    }
}
export default Home;